import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGb = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 1024,
	height: 1024,
	viewBox: "0 0 1024 1024",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_3_23366)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M0 0H1024V1024H0V0Z",
				fill: "#012169"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1024 0V128L644 512L1024 886V1024H890L508 648L136 1024H0V888L372 514L0 148V0H124L508 376L880 0H1024Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M368 648L390 716L84 1024H0V1018L368 648ZM616 624L724 640L1024 934V1024L616 624ZM1024 0L640 392L632 304L932 0H1024ZM0 2L386 380L268 364L0 98V2Z",
				fill: "#C8102E"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M352 0V1024H672V0H352ZM0 352V672H1024V352H0Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 416V608H1024V416H0ZM416 0V1024H608V0H416Z",
				fill: "#C8102E"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3_23366",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 1024,
			height: 1024,
			rx: 512,
			fill: "white"
		})
	}) })]
});
export default SvgGb;
